import {RouteConfig} from 'vue-router';

export const aboutRoutes : RouteConfig = {
  path: 'about',
  component: () => import('@/views/public/about/AboutView.vue'),
  children: [
    {
      path: '',
      name: 'about',
      component: () => import('@/views/public/about/index/AboutIndex.vue'),
    },
  ],
};
